import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { LicensesTableComponent } from './licenses-table/licenses-table.component';
import { LicenseHolderComponent } from './licenses-table/license-holder/license-holder.component';
import { InviteUserDialogComponent } from './licenses-table/license-holder/invite-user-dialog/invite-user-dialog.component';
import { LicenseManagementComponent } from './license-management.component';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { LicensePlanBadgeModule } from '@go-modules/components/license-plan-badge/license-plan-badge.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		TranslateModule,
		GoMaterialModule,
		FocusOnFirstInvalidFieldModule,
		NgxZeroStateModule,
		LicensePlanBadgeModule,
		GoCdkPopoverDirective
	],
	declarations: [
		LicenseManagementComponent,
		LicensesTableComponent,
		LicenseHolderComponent,
		InviteUserDialogComponent
	],
	providers: [
		TranslatePipe
	]
})
export class LicenseManagementModule {}
